import { useEffect } from "react";

// While `isDirty`, asks the browser to confirm before the tab is closed, refreshed or navigated
// away. In-app navigation is not covered - BrowserRouter has no blocker API.
export const useUnsavedChangesWarning = (isDirty: boolean): void => {
  useEffect(() => {
    if (!isDirty) return;
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      // preventDefault alone triggers the browser's confirm prompt in all current browsers.
      event.preventDefault();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDirty]);
};
